import React from "react";
import { Link } from "react-router-dom";

export function CaseStudiesSection() {
  const cases = [
    {
      title: "Woning Elst: 10 panelen + hybride warmtepomp",
      summary:
        "Combinatieoplossing met optimaal rendement: 4.2 kWp zonnepanelen en hybride warmtepomp voor verwarming en koeling.",
      stats: ["-30% gasverbruik", "+4.100 kWh/jaar", "Terugverdientijd ~5,5 jaar"],
    },
    {
      title: "MKB Arnhem: 36 panelen en laadpalen",
      summary:
        "Dakoplossing met monitoring en 2 laadpunten. Dynamisch contract benut voor slimme verbruikstijden.",
      stats: ["-22% energiekosten", "+13.500 kWh/jaar", "Installatie in 2 dagen"],
    },
  ];

  return (
    <section aria-labelledby="cases-heading" className="py-16">
      <div className="container mx-auto px-4">
        <header className="mb-8 text-center">
          <h2 id="cases-heading" className="text-3xl md:text-4xl font-bold tracking-tight">
            Projecten uitgelicht
          </h2>
          <p className="text-muted-foreground mt-2">
            Praktische voorbeelden van onze aanpak en resultaten.
          </p>
        </header>

        <div className="grid gap-6 md:grid-cols-2">
          {cases.map((c, i) => (
            <article key={i} className="bg-card text-card-foreground border border-border rounded-lg p-6 shadow-sm">
              <h3 className="text-xl font-semibold">{c.title}</h3>
              <p className="text-muted-foreground mt-2">{c.summary}</p>
              <ul className="mt-4 space-y-1 text-sm">
                {c.stats.map((s, j) => (
                  <li key={j} className="text-foreground">{s}</li>
                ))}
              </ul>
              <div className="mt-4">
                <Link to="/contact" className="underline hover:text-primary">
                  Meer weten over dit project
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CaseStudiesSection;
